/**
 * BD Coupon Logik (Birthday Sale).
 * Module: Click-to-Apply (Warenkorb-Update), Countdown, Anzeige-Logik (Bars, Karten, PDP).
 * Benoetigt: COUPON_ENTRY_INFO_LIST (siehe snippets/bd-coupon-init.liquid).
 *
 * Zustandslogik:
 *  - Klick auf den Code => sofort gruen (optimistisch, localStorage) + Code im Warenkorb anwenden.
 *  - Warenkorb hat den anwendbaren Code => aktiv (gruen).
 *  - Warenkorb hat Artikel, aber KEINEN anwendbaren Code (Code wurde entfernt) => zurueck auf inaktiv.
 *  - Leerer Warenkorb => optimistischen Klick-Zustand halten.
 *
 * Preisdarstellung (14.07.2026):
 *  - PDP UND Collection-Karte zeigen IMMER den nativen Preisblock aus snippets/price.liquid:
 *    Streichpreis (compare_at_price) + "Dein Preis" (price).
 *  - Der Coupon-Rabatt wird NICHT in den angezeigten Preis eingerechnet, sondern nur als Badge
 *    kommuniziert. Der Rabatt greift im Warenkorb.
 */
(function () {
  'use strict';

  var ENTRIES = typeof COUPON_ENTRY_INFO_LIST !== 'undefined' ? COUPON_ENTRY_INFO_LIST : [];
  var ACTIVATED_KEY = 'bd_coupon_activated';
  var applying = false;

  /* ---------- Helpers ---------- */
  function pad(n) {
    return String(n).padStart(2, '0');
  }
  function setHtml(el, html) {
    if (el.innerHTML !== html) el.innerHTML = html;
  }
  function maxDiscountPercent(entry, idListString) {
    var ids = (idListString || '').trim().split(',');
    var percent = 0;
    ids.forEach(function (id) {
      if (id === '') return;
      (entry.collection_discount_percent_list || []).forEach(function (item) {
        if (String(item.collection_id) === String(id).trim() && item.discount_percent > percent) {
          percent = item.discount_percent;
        }
      });
    });
    return percent;
  }
  function entryActive(entry) {
    var end = new Date(entry.end_date);
    var now = new Date(entry.current_date);
    return !isNaN(end.getTime()) && !isNaN(now.getTime()) && end - now > 0;
  }

  /* Persistierter Aktiv-Zustand (per Klick gesetzt) */
  function getActivatedCode() {
    try { return localStorage.getItem(ACTIVATED_KEY); } catch (e) { return null; }
  }
  function setActivatedCode(code) {
    try { localStorage.setItem(ACTIVATED_KEY, code); } catch (e) {}
  }
  function clearActivatedCode() {
    try { localStorage.removeItem(ACTIVATED_KEY); } catch (e) {}
  }
  function activatedEntry() {
    var code = getActivatedCode();
    if (!code) return null;
    var match = null;
    ENTRIES.forEach(function (entry) {
      if (entry.code_title === code) match = entry;
    });
    if (match && !entryActive(match)) {
      clearActivatedCode();
      return null;
    }
    return match;
  }

  /* Welcher Eintrag soll angezeigt werden? */
  function decideEntry() {
    /* Waehrend des Anwendens nicht auf inaktiv zurueckfallen */
    if (applying) {
      return findAppliedEntry(lastDiscountCodes) || activatedEntry();
    }
    var cartEntry = findAppliedEntry(lastDiscountCodes);
    if (cartEntry) {
      setActivatedCode(cartEntry.code_title);
      return cartEntry;
    }
    /* Warenkorb hat Artikel, aber keinen (mehr) anwendbaren Code => Code wurde
       entfernt => zurueck auf inaktiv. */
    if ((lastItemCount || 0) > 0) {
      clearActivatedCode();
      return null;
    }
    /* Leerer Warenkorb => optimistischen Klick-Zustand halten */
    return activatedEntry();
  }

  /* ---------- 1) Klick auf Code => sofort umschalten + Code anwenden ---------- */
  document.addEventListener('click', function (e) {
    var wrapper = e.target.closest('[js-discount-appliable-wrapper]');
    if (!wrapper) return;
    var codeEl = wrapper.querySelector('[data-code]');
    var code = codeEl && codeEl.getAttribute('data-code');
    if (!code) return;
    setActivatedCode(code);
    applyDisplay(activatedEntry());
    applyDiscountCode(code);
  });

  function applyDiscountCode(code) {
    applying = true;
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var updateUrl = routes.cart_update_url || '/cart/update';
    if (updateUrl.indexOf('.js') === -1) updateUrl += '.js';
    var cartUrl = routes.cart_url || '/cart';
    var sections = [];
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
      );
    } catch (e) {}
    var fd = new FormData();
    fd.append('discount', code);
    fd.append('sections', sections.join(','));
    fd.append('sections_url', window.location.pathname);
    fetch(updateUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
      body: fd,
      credentials: 'same-origin'
    })
      .then(function (res) { return res.json(); })
      .then(function (parsed) {
        return fetch(cartUrl + '.js', { credentials: 'same-origin' })
          .then(function (res) { return res.json(); })
          .then(function (cartJson) {
            cartJson.sections = parsed.sections;
            if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
              FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            }
            lastDiscountCodes = cartJson.discount_codes || [];
            lastItemCount = cartJson.item_count || 0;
            applying = false;
            applyDisplay(decideEntry());
          });
      })
      .catch(function () {
        applying = false;
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () { refresh(); })
          .catch(function () {});
      });
  }

  /* ---------- 2) Countdown ---------- */
  function initTimer(el) {
    if (el.hasAttribute('data-countdown-inited')) return;
    el.setAttribute('data-countdown-inited', 'true');
    var end = new Date(el.getAttribute('js-coupon-left-time'));
    var serverNowAttr = el.getAttribute('js-current-time');
    var serverNow = serverNowAttr ? new Date(serverNowAttr) : new Date();
    if (isNaN(end.getTime()) || isNaN(serverNow.getTime())) return;
    var baseDiff = end - serverNow;
    var startedAt = Date.now();
    var interval = null;
    function tick() {
      var remaining = baseDiff - (Date.now() - startedAt);
      if (remaining <= 0) {
        el.textContent = '00:00:00:00';
        if (interval) clearInterval(interval);
        return;
      }
      var s = Math.floor(remaining / 1000);
      el.textContent = pad(Math.floor(s / 86400)) + ':' + pad(Math.floor(s / 3600) % 24) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
    }
    tick();
    interval = setInterval(tick, 1000);
  }
  function initAllTimers(root) {
    (root || document).querySelectorAll('[js-coupon-left-time]').forEach(initTimer);
  }

  /* ---------- 3) Anzeige-Logik ---------- */
  function findAppliedEntry(discountCodes) {
    var found = null;
    (discountCodes || []).forEach(function (dc) {
      if (!dc || dc.applicable === false) return;
      ENTRIES.forEach(function (entry) {
        if (dc.code === entry.code_title) found = entry;
      });
    });
    if (found && !entryActive(found)) found = null;
    return found;
  }

  function applyDisplay(entry) {
    document.querySelectorAll('.bd-coupon-bar-applied--wrapper').forEach(function (el) {
      if (!entry) {
        el.classList.add('d-none');
        return;
      }
      el.classList.remove('d-none');
      var templateText = el.querySelector('[data-template]');
      if (templateText) {
        setHtml(templateText, String(templateText.getAttribute('data-template')).replace('((code))', entry.code_title));
      }
    });
    document.querySelectorAll('.bd-coupon-bar--wrapper').forEach(function (el) {
      if (entry) el.classList.add('d-none');
      else el.classList.remove('d-none');
    });

    /* PDP Sale-Timer-Box (mh-timer): Text wechselt in den Aktiv-Zustand */
    document.querySelectorAll('.mh-timer').forEach(function (box) {
      if (entry) box.classList.add('mh-timer--active');
      else box.classList.remove('mh-timer--active');
    });

    /* Header-DAYS-Leiste (.daysa) + Collection-Banner (.daysc) + Sale Code Bar (.scb):
       gleicher Aktiv-Zustand wie der PDP-Timer */
    document.querySelectorAll('.daysa, .daysc, .scb').forEach(function (el) {
      if (entry) el.classList.add('is-days-active');
      else el.classList.remove('is-days-active');
    });

    /* Collection-Karte: Preisblock IMMER nativ (compare_at_price + "Dein Preis") - analog PDP.
       Der alte Coupon-Preisblock (.card__price-with-coupon) kennt compare_at_price nicht und
       hat den Rabatt faelschlich in den Preis gerechnet => wird dauerhaft ausgeblendet.
       Der Rabatt wird nur noch ueber das Badge (.card__badge-with-coupon) kommuniziert. */
    document.querySelectorAll('product-card').forEach(function (card) {
      var priceWithCoupon = card.querySelectorAll('.card__price-with-coupon');
      var priceWithoutCoupon = card.querySelectorAll('.card__price-without-coupon');
      var badges = card.querySelectorAll('.card__badge-with-coupon');
      var percent = 0;
      if (entry) percent = maxDiscountPercent(entry, card.getAttribute('data-collection-id-list'));

      priceWithCoupon.forEach(function (el) { el.classList.add('d-none'); });
      priceWithoutCoupon.forEach(function (el) { el.classList.remove('d-none'); });

      var soldOut = !!card.querySelector('.f-price--sold-out') || !!card.querySelector('.f-badge--soldout');
      badges.forEach(function (el) {
        if (!entry || percent === 0 || soldOut) {
          el.classList.add('d-none');
          return;
        }
        el.classList.remove('d-none');
        setHtml(el, '-' + percent + '%');
      });
    });

    /* PDP-Preis: Coupon-Block NICHT anzeigen. Stattdessen bleibt der bestehende
       .f-price sichtbar; bei aktivem Code wird ein Badge neben "Dein Preis" gezeigt (Farbe bleibt gleich). */
    document.querySelectorAll('.price__container-with-coupon').forEach(function (container) {
      var percent = 0;
      if (entry) percent = maxDiscountPercent(entry, container.getAttribute('data-collection-id-list'));
      container.classList.add('d-none');
      var fprice = container.nextElementSibling;
      if (!fprice || !fprice.classList || !fprice.classList.contains('f-price')) return;
      fprice.classList.remove('d-none');
      var saleBlock = fprice.querySelector('.sale_price_block') || fprice.querySelector('.f-price__sale');
      var badge = saleBlock ? saleBlock.querySelector('.mh-coupon-badge') : null;
      if (!entry || percent === 0) {
        fprice.classList.remove('is-coupon-active');
        if (badge) badge.style.display = 'none';
        return;
      }
      fprice.classList.add('is-coupon-active');
      if (saleBlock) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'mh-coupon-badge'; saleBlock.appendChild(badge); }
        /* 08.09.2026: Enddatum hier bewusst NICHT anzeigen - es steht bereits in der
           Sale-Box unter dem Preis (mh-sale-timer-block, 2. Zeile). */
        setHtml(badge, '-' + percent + '% mit Code ' + entry.code_title);
        badge.style.display = '';
      }
    });
  }

  var lastDiscountCodes = null;
  var lastItemCount = 0;
  function refresh() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        lastDiscountCodes = cart.discount_codes || [];
        lastItemCount = cart.item_count || 0;
        applyDisplay(decideEntry());
      })
      .catch(function () {
        applyDisplay(activatedEntry());
      });
  }

  function init() {
    initAllTimers(document);
    applyDisplay(activatedEntry());
    refresh();
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'variant:change:end'].forEach(function (evt) {
      document.addEventListener(evt, refresh);
    });
    var debounce = null;
    var observer = new MutationObserver(function (mutations) {
      var relevant = false;
      for (var i = 0; i < mutations.length; i++) {
        var t = mutations[i].target;
        var elT = t.nodeType === 1 ? t : t.parentElement;
        if (!elT) continue;
        if (elT.closest('[js-coupon-left-time]')) continue;
        if (elT.closest('.f-price')) continue;
        relevant = true;
        break;
      }
      if (!relevant) return;
      if (debounce) clearTimeout(debounce);
      debounce = setTimeout(function () {
        initAllTimers(document);
        if (lastDiscountCodes !== null) applyDisplay(decideEntry());
        else applyDisplay(activatedEntry());
      }, 300);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
